import React, { useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { useAddBlogMutation } from "src/services/BlogServices";
import { BlogFormValues } from "src/models/Blog.model";
import BlogForm from "../Layout/BlogForm";

const AddBlogFormWrapper = () => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addBlog] = useAddBlogMutation();

  // Form Initial Values
  const initialValues: BlogFormValues = {
    bannerImage: "",
    title: "",
    description: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    title: string().required("Please enter blog title"),
    description: string().required("Please enter blog description"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BlogFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BlogFormValues>
  ) => {
    const formatedValue = {
      bannerImage: values.bannerImage,
      title: values.title,
      description: values.description,
    };

    addBlog(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            // onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          <BlogForm
            formikProps={formikProps}
            formType="Add"
            setSaveNextChecked={setSaveNextChecked}
            saveNextChecked={saveNextChecked}
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddBlogFormWrapper;
